import { render, staticRenderFns } from "./HotelsAdvanced.vue?vue&type=template&id=a27cd2e6&scoped=true&"
import script from "./HotelsAdvanced.vue?vue&type=script&lang=js&"
export * from "./HotelsAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./HotelsAdvanced.vue?vue&type=style&index=0&id=a27cd2e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27cd2e6",
  null
  
)

export default component.exports